import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { Dispatch, SetStateAction } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type OpenFiltersButtonProps = {
    setOpen: Dispatch<SetStateAction<boolean>>;
    className?: string;
};

const OpenFiltersButton = ({ setOpen, className }: OpenFiltersButtonProps) => {
    const { t } = useGranite();

    const handleOnFilterButtonClick = () => setOpen(() => true);

    return (
        <Button
            type={"button"}
            className={cn("tw:text-left tw:cursor-pointer", className)}
            color={"gray"}
            onClick={handleOnFilterButtonClick}
        >
            <i className={cn("las la-filter", "tw:mr-2")} />
            {t("search.refinements.showFiltersButton")}
        </Button>
    );
};

export { OpenFiltersButton };
